import { HttpStatusCode } from "@kaladel/react/Utilities";
import { ConfigurationClient, ConfigurationGetResponse } from "ConfigurationApiClient/ConfigurationApiClient";

export class Configuration {
    private static globalContext: ConfigurationGetResponse;

    static get(): ConfigurationGetResponse {
        return this.globalContext;
    }

    static async refresh() {
        const client = new ConfigurationClient();
        const response = await client.get();
        if (response.status === HttpStatusCode.Http200Ok) {
            this.setContext(response.result);
        }
    }

    private static setContext(newContext: ConfigurationGetResponse) {
        this.globalContext = newContext;
    }
}